export default {
    forgot_password_username: 'Username',
    forgot_password_password: 'Password',
    forgot_password_confirm_password: 'Confirm Password',
    forgot_password_required_filed: 'Required field',
    forgot_password_forgot_password: 'Forgot Password?',
    forgot_password_change_password: 'Change Password',
    forgot_password_sign_in_with_google: 'Sign In With Google',
    forgot_password_confirm_new_password: 'Confirm New Password',
    page_not_found: 'Oops! We´ve hit a speed bump',
    page_not_found_message: 'The page you are looking for seems to be missing. If you need a ride someplace else, try one of the buttons on the left',
    forgot_password_email: 'Email',
    forgot_password_confirm_password_error: 'Passwords do not match',
    forgot_password_error: 'Error',
};


